import Page from '../common/page'

const state = Object.assign({}, Page.state)
state.endpoint = 'groups/'

export default {
  namespaced: true,
  state,
  getters: Page.getters,
  mutations: Page.mutations,
  actions: Page.actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/groups/groups.js